/* global __CLIENT__*/

import React from 'react';
import logo from '../../static/img/planz-logo-white.svg';
import '../../styles/Login.css';

const IEWarning = () => {
  return (
    <div className="wrapper">
      <div style={{ width: 1000, textAlign: 'center', color: '#fff' }}>
        <img src={logo} className="loginLogo" width={300} alt="Sight Logo" />
        <div>Internet Explorer is not a supported browser. For best results, try Chrome, Firefox, Safari, or Edge.</div>
      </div>
    </div>
  );
};

export default IEWarning;



// WEBPACK FOOTER //
// ./src/components/states/IEWarning.js